import { render, staticRenderFns } from "./newRequirement.vue?vue&type=template&id=64765e5a&"
import script from "./newRequirement.vue?vue&type=script&lang=js&"
export * from "./newRequirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports